import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import * as moment from 'moment';
import { DaysMenuRequestBody, DaysMenuResponse } from '../Models/days-menu';

@Injectable({
  providedIn: 'root',
})
export class TodayMenuService {
  OBPortalSvcURL = '';
  headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private appConfigService: AppConfigService,
    private httpClient: HttpClient) {
      this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
  }

  public getTodaysMenu(shpId: number | undefined): Observable<DaysMenuResponse> {
    const todaysMenu = new DaysMenuRequestBody(shpId, moment().format('YYYY-MM-DD'));

    return this.httpClient.post<DaysMenuResponse>(`${this.OBPortalSvcURL}GetDaysMenu`, todaysMenu, { headers: this.headers });
  }
}
